import { Input } from "@/components/ui/input";

export const ReportTitle: React.FC<{
  title: string;
  isTitleFocused: boolean;
  onTitleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  setIsTitleFocused: (focused: boolean) => void;
  canEdit: boolean;
}> = ({ title, isTitleFocused, onTitleChange, setIsTitleFocused, canEdit }) => {
  if (isTitleFocused && canEdit) {
    return (
      <Input
        value={title}
        onChange={onTitleChange}
        className="text-xl font-semibold h-9 mr-10 focus-visible:ring-1 text-ellipsis"
        placeholder="Enter report title"
        autoFocus
        onBlur={() => setIsTitleFocused(false)}
      />
    );
  }

  return (
    <div
      className="text-xl font-semibold break-words cursor-text"
      title={title}
      onClick={() => canEdit && setIsTitleFocused(true)}
    >
      {title || "Untitled Report"}
    </div>
  );
};
